export default "__VITE_ASSET__CBaEhOFI__"